/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Img from 'gatsby-image';
import { Box, Flex } from '../components/Layout';
import colors from '../utils/colors';

const style = css`
  text-align: center;
  padding-bottom: 10%;
  & ul {
    list-style-type: none;
    color: ${colors.primary};
  }
  h1 {
    padding-bottom: 0em;
    padding-top: 1em;
  }
  h2 {
    font-family: Tajawal
  }
`;

const yhtStyle = css`
  h3 {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: space-around;
`;

const outerImgWrapper = css`
  width: 50%;
  min-width: 5em;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2em;
`;

const outerImgWrapper2 = css`
  width: 50%;
  min-width: 5em;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4em;
`;

const outerImgWrapper3 = css`
  width: 35%;
  min-width: 5em;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4em;
`;

const secondarySponsor = css`
  ${outerImgWrapper};
  width: 35%;
  padding-top: 1em;
`;

const Yhteistyossa = ({ data }) => {
  const { skr, taike, omavarasto, arina } = data;
  return (
    <Box>
      <Box
        width={[1, 1, 1 / 2]}
        className={style}
        m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
        px={[3, 3, 0]}
        color={colors.secondary}
      >
        <h1>Apurahat</h1>
        <div className={yhtStyle}>
          <Img
            alt="SKR"
            outerWrapperClassName={outerImgWrapper}
            sizes={skr.childImageSharp.sizes}
            imgStyle={{ objectFit: 'contain' }}
          />
          <Img
            alt="TAIKE"
            outerWrapperClassName={outerImgWrapper2}
            sizes={taike.childImageSharp.sizes}
            imgStyle={{ objectFit: 'contain' }}
          />
        </div>
        <h1>Lipunmyyntiyhteistyö</h1>
        <div className={yhtStyle}>
        <Img
          alt="Arina"
          outerWrapperClassName={outerImgWrapper3}
          sizes={arina.childImageSharp.sizes}
          imgStyle={{ objectFit: 'contain' }}
        />
        </div>
        <h1>Sponsorit</h1>
        <div className={yhtStyle}>
          <Img
            alt="Oulun Omavarasto"
            outerWrapperClassName={secondarySponsor}
            sizes={omavarasto.childImageSharp.sizes}
            imgStyle={{ objectFit: 'contain' }}
          />
        </div>
        <h2>Peab Oy</h2>
        <h2>Glamour</h2>
        <h2>Tanssipaku</h2>
      </Box>
    </Box>
  );
};

export const query = graphql`
  query YhteistyossaQuery {
    skr: file(relativePath: { eq: "skr.png" }) {
      childImageSharp {
        sizes(maxWidth: 1024) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    taike: file(relativePath: { eq: "taike.png" }) {
      childImageSharp {
        sizes(maxWidth: 1024) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    arina: file(relativePath: { eq: "arinalogo.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1024) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    omavarasto: file(relativePath: { eq: "omavarasto.png" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;
export default Yhteistyossa;



// WEBPACK FOOTER //
// ./src/pages/yhteistyossa.js